import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 12178 14655"
    {...props}
  >
    <path
      d="M6280 14655H1801c-648 0-1109-143-1385-433S0 13468 0 12837V1818C0 1173 143 710 426 426 709 143 1166 0 1801 0h4749c699 0 1306 44 1818 130 515 88 975 252 1381 501 348 205 652 468 921 785 266 317 468 665 608 1047 139 385 211 788 211 1214 0 1467-733 2542-2200 3221 1927 614 2889 1804 2889 3578 0 819-211 1559-631 2214-419 658-986 1143-1699 1453-447 188-958 321-1538 396-580 78-1259 116-2030 116zm-222-6509H2968v4278h3189c2009 0 3012-723 3012-2170 0-740-259-1275-781-1610-518-331-1296-498-2330-498zM2968 2231v3786h2722c740 0 1310-71 1712-211 406-140 713-406 928-798 167-280 249-594 249-938 0-741-262-1232-791-1474-525-242-1331-365-2408-365H2968z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
